import type { AnyStartInstance } from '@tanstack/start-client-core'

export const startInstance: AnyStartInstance | undefined = undefined
